import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import RequireAccess from "@/components/RequireAccess";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import CheckoutReturn from "@/pages/CheckoutReturn";
import AccessKey from "@/pages/AccessKey";
import Portal from "@/pages/Portal";
import Dashboard from "@/pages/Dashboard";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Investors from "@/pages/Investors";
import Forests from "@/pages/Forests";
import Sales from "@/pages/Sales";
import Edge from "@/pages/Edge";

function App() {
  return (
    <div className="App noise-overlay">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:slug" element={<EventDetail />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/forests" element={<Forests />} />
            <Route path="/sales" element={<Sales />} />
            <Route path="/edge" element={<Edge />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkout/return" element={<CheckoutReturn />} />
            <Route
              path="/access-key"
              element={
                <ProtectedRoute>
                  <AccessKey />
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal"
              element={
                <RequireAccess>
                  <Portal />
                </RequireAccess>
              }
            />
            <Route
              path="/dashboard"
              element={
                <RequireAccess>
                  <Dashboard />
                </RequireAccess>
              }
            />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "rgba(15,23,42,0.9)",
              border: "1px solid rgba(0,229,255,0.25)",
              color: "#F8FAFC",
              backdropFilter: "blur(12px)",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
